<div dir="rtl" class="justify-content-center align-items-center bg-gredient position-relative">
  <div class="row m-0 justify-content-center justify-content-center vh-100">
    <div class="col-12 col-lg-8 text-center">
      <h2 class="text-center main-text">دعوة حضور</h2>
      <img src="../../../../assets/images/windorex-logo.png" class="align-middle m-auto" alt="logo"/>
    </div>
    <div class="col-lg-8 col-12 d-flex align-items-center">
      <mat-card class="cardWithShadow w-100 m-t-md m-b-md">
        <mat-card-content class="p-32 text-center">
          شكرا لطلبك الدعوه، يمكنك تحميل الدعوة من <a href="{{url}}" target="_blank">هنا</a>
          <div class="m-t-30">
            <button (click)="copyUrl()" color="primary" mat-flat-button>نسخ رابط الدعوه</button>
            <input type="text" id="url" value="{{url}}" style="display: none">
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-lg-8 col-12 logo-footer">
      <img src="../../../../assets/images/polywin-Logo.png" alt="logo"/>
      <img src="../../../../assets/images/KEMETWIN-Logo.png" class="m-l-auto" alt="logo"/>
    </div>
  </div>
</div>

